module.exports = "<button class=\"btn btn-link\" (click)=\"logout()\">Logout</button>\r\n"